import { AmplitudeProvider } from "@crehana/analytics";

/** @deprecated Please use the `@crehana/analytics` library. */
var AmplitudeLayout = AmplitudeProvider;
export default AmplitudeLayout;